import { Component, OnInit } from '@angular/core';
import { Router, Event as RouterEvent } from '@angular/router';
import { MaintenanceService } from './Authentication/Helpers/maintenance.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app',
    templateUrl: 'app.component.html',
    standalone: false
})

export class AppComponent implements OnInit {
  public showHeader: any;
  //  Sets initial value to true to show loading spinner on first load
  loading = true;

  constructor(
    private router: Router,
    private maintenanceService: MaintenanceService,
    private swUpdate: SwUpdate,
    private toastr: ToastrService) {
    this.showHeader = localStorage.getItem('userSession');
    router.events.subscribe((event: RouterEvent) => {
      this.showHeader = localStorage.getItem('userSession');
    });
  }

  ngOnInit() {
    this.maintenanceService.isMaintenance$.subscribe((isMaintenance) => {
      if (isMaintenance) {
        // Redirect to maintenance page if not already there
        if (this.router.url !== '/maintenance') {
          this.router.navigate(['/maintenance']);
        }
      }
    });

    // Check for service worker updates
    this.checkForUpdates();
  }

  private checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // Listen for version updates
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(() => {
        this.showUpdateNotification();
      });

    // Check for updates every 6 hours
    setInterval(() => {
      this.swUpdate.checkForUpdate();
    }, 6 * 60 * 60 * 1000);

    // Check for updates immediately
    this.swUpdate.checkForUpdate();
  }

  private showUpdateNotification(): void {
    const toast = this.toastr.info(
      'Er is een nieuwe frontend versie beschikbaar',
      '',
      {
        disableTimeOut: true,
        closeButton: true,
        tapToDismiss: false,
        positionClass: 'toast-bottom-right',
        enableHtml: true,
        messageClass: 'update-toast-message'
      }
    );

    if (toast) {
      toast.onTap.subscribe(() => {
        this.reloadApp();
      });
    }

    // Add reload button to the toast
    setTimeout(() => {
      const toastElement = document.querySelector('.toast-bottom-right .toast-message');
      if (toastElement && !toastElement.querySelector('.reload-button')) {
        const button = document.createElement('button');
        button.className = 'btn btn-primary btn-sm mt-2 reload-button';
        button.textContent = 'Herladen';
        button.onclick = () => this.reloadApp();
        toastElement.appendChild(button);
      }
    }, 100);
  }

  private reloadApp(): void {
    this.swUpdate.activateUpdate().then(() => {
      document.location.reload();
    });
  }
}
